import styled from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

import { IProductsCount } from '../model';

import { fifteenPx, colPct } from '.';

export const RoutineContentWrapper = styled.div<IProductsCount>`
  padding: ${fifteenPx} 0 0;
  background: ${theme.color.background.disabled};
  display: block;

  @media (min-width: ${breakpoints.md}) {
    margin-bottom: 0;
    padding-bottom: ${fifteenPx};
    display: ${(props) => (props.productsCount === 4 ? 'block' : 'flex')};
  }
`;

export const RoutineProducts = styled.div<IProductsCount>`
  display: flex;
  margin: ${fifteenPx} 0 0;
  background: ${theme.color.background.primary};
  ${(props) =>
    props.productsCount === 4
      ? ''
      : `flex: 1 1 ${props.productsCount === 3 ? colPct(8) : colPct(7)};`};
  flex-wrap: wrap;
  padding: 0 0.5rem;

  @media (min-width: ${breakpoints.md}) {
    margin: ${fifteenPx} 0 0;
    flex-wrap: nowrap;
    margin: ${(props) => (props.productsCount === 4 ? fifteenPx : 0)}
      ${fifteenPx} 0;
  }
`;
